var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import validator from 'validator';
import history from '../../history';
import authService from 'services/authServise';
import { ResponseErrors } from 'common/enums/common/response-errors.enum';
export var RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export var RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export var RESET_PASSWORD = 'RESET_PASSWORD';
export function setResetPasswordForm(payload) {
    return {
        type: RESET_PASSWORD,
        payload: __assign({}, payload)
    };
}
export function setResetPasswordSuccess() {
    return {
        type: RESET_PASSWORD_SUCCESS
    };
}
export function setResetPasswordError(error) {
    return {
        type: RESET_PASSWORD_ERROR,
        payload: error
    };
}
export function cleanResetPasswordError() {
    return {
        type: RESET_PASSWORD_ERROR,
        payload: {}
    };
}
/********************************************************/
export function forgotPassword(payload) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authService.forgotPassword(payload)];
                case 1:
                    _a.sent();
                    dispatch(setResetPasswordForm(__assign(__assign({}, payload), { isVisible: true })));
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    dispatch(setResetPasswordError(error_1));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function resetPasswordVerification(id) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var params, error_2, errorCode;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    params = {
                        params: { id: id }
                    };
                    return [4 /*yield*/, authService.resetPasswordVerification(params)];
                case 1:
                    _a.sent();
                    dispatch(setResetPasswordForm({ isVerified: true, isIdValid: true }));
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    errorCode = error_2.errorCode;
                    if (errorCode && validator.equals(errorCode, ResponseErrors.VerificationNotFound)) {
                        dispatch(setResetPasswordError(error_2));
                    }
                    else {
                        dispatch(setResetPasswordError(error_2));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
export function saveNewPassword(payload) {
    var _this = this;
    return function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, authService.saveNewPassword(payload)];
                case 1:
                    _a.sent();
                    history.push('/');
                    return [3 /*break*/, 3];
                case 2:
                    error_3 = _a.sent();
                    dispatch(setResetPasswordError(error_3));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
}
